// No overlay on navigation (2026-10-30): browsers keep the current page on screen until the next one can
// paint, and the white logo overlay used to hide that, so every click showed a blank page. checkout.js still
// shows it while its AJAX steps run.

// Instead, a 2px bar at the very top while the next page loads. Started on beforeunload, i.e. only when a
// navigation really begins (links handled in JS never trigger it); hidden after 15 s if the page stays
// (a file download) and when the page comes back from the back/forward cache.
(function () {
    let bar = null;
    let timer = null;
    const stop = function () {
        clearTimeout(timer);
        if (bar) {
            bar.classList.remove('xt-nav-progress-run');
        }
    };
    window.addEventListener('beforeunload', function () {
        if (!bar) {
            bar = document.createElement('div');
            bar.className = 'xt-nav-progress bg-pink';
            document.body.appendChild(bar);
            void bar.offsetWidth;   // start the transition from width 0
        }
        bar.classList.add('xt-nav-progress-run');
        clearTimeout(timer);
        timer = setTimeout(stop, 15000);
    });
    window.addEventListener('pageshow', stop);
})();
$(window).ready(function() {
    $(".se-pre-con").fadeOut("fast");

});
window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        $('.se-pre-con').fadeOut("fast");
    }
});

$('form').on('submit', function( event ) {
    const submitButton = $(this).find('button[type="submit"]');
    if(submitButton.length) {
        const buttonContent = submitButton.html();
        submitButton.prop('disabled', true);
        submitButton.html('<i class="fa-sharp fa-light fa-loader fa-spin"></i> Loading...');
        setTimeout(function () {
            submitButton.prop('disabled', false);
            submitButton.html(buttonContent);
        }, 5000)
    }
});
